// src/components/DiscountBanner.js

import React from "react";

const DiscountBanner = () => {
  return (
    <div
      className="fixed top-0 left-0 w-full text-center py-2 z-50 shadow-md"
      style={{ backgroundColor: '#077573' }} // Custom background color
    >
      <a
        href="https://link.embarkx.com/spring-security"
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold hover:underline"
        style={{ color: '#EBE2D4' }} // Custom text color
      >
        Join this Udemy course at the lowest price before it's gone!
      </a>
    </div>
  );
};

export default DiscountBanner;
